import { useTranslation } from 'react-i18next';

import { Separator } from '@/components/ui/separator';

import { buildTurnHighlights } from './buildTurnHighlights';
import { buildTurnIssues } from './buildTurnIssues';
import { TurnHighlights } from './TurnHighlights';
import { TurnIssues } from './TurnIssues';
import { dialogsByNode, useDialogsList } from '../../../hooks/useDialogsList';
import { ConversationTurn } from '../../../types/conversation';

type Props = { turn: ConversationTurn };

export const TurnSummary = ({ turn }: Props) => {
  const { t } = useTranslation();
  const dialogs = useDialogsList();

  const byNode = dialogsByNode(dialogs);
  const dialogOfNode = (nodeId?: string) => {
    const dialog = nodeId ? byNode.get(nodeId) : undefined;
    return dialog ? { id: dialog.dialog_id, name: dialog.name } : null;
  };

  const issues = buildTurnIssues(t, turn);
  const highlights = buildTurnHighlights(t, turn, dialogOfNode);

  if (issues.length === 0 && highlights.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-6">
      <Separator />
      {issues.length > 0 && <TurnIssues issues={issues} />}
      {highlights.length > 0 && <TurnHighlights highlights={highlights} />}
    </div>
  );
};
